namespace ui
{
	export namespace dialog
	{

		let MODAL_TARGET: JQuery;

		$( document ).ready(
			() =>
			{
				// Initializing modal targets
				MODAL_TARGET = ui.$$.div().css(
					{
						'background-color': 'transparent',
						'max-height': '0px'
					}
				).appendTo( $( document.body ) );
			},
		);

		export interface IModalDescriptor extends ui.base.IBaseHTMLElementDescriptor
		{
			head?:          Array<JQuery|ui.base.BaseHTMLElement>;
			body?:          Array<JQuery|ui.base.BaseHTMLElement>;
			foot?:          Array<JQuery|ui.base.BaseHTMLElement>;
			noFade?:        boolean;
			noCloseBtn?:	boolean;
			isForm?:        boolean;
			backdrop?:      boolean | 'static';
			size?:          'lg'|'sm'|'quick7';
		}

		export class Modal
			extends ui.base.BaseHTMLElement<HTMLDivElement>
		{

			public constructor( descriptor?: IModalDescriptor )
			{
				const isForm = descriptor && descriptor.isForm;

				super(isForm ? 'form' : 'div');

				this.Initialize( descriptor || {} );

				this.m_Root.modal( {
					backdrop: descriptor ? descriptor.backdrop : true,
					keyboard: true,
					show: true,
				});

				this.appendTo( MODAL_TARGET );

				this.on( 'hidden.bs.modal', () => this.remove() );
			}

			public Initialize( descriptor: IModalDescriptor )
			{
				super.Initialize( descriptor );

				this.addClass( 'modal' );
				this.attr( 'role', 'dialog' );
				this.attr( 'tabindex', '-1' );

				if ( !( descriptor.noFade === false ) )
				{
					this.addClass( 'fade' );
				}

				const cntnt: JQuery = ui.$$.div().addClass( 'modal-content' ) // modal-content div for header, body and footer
					.appendTo(
						ui.$$.div().attr( 'role', 'document' )
						.addClass( 'modal-dialog' + ( descriptor.size ? ' modal-' + descriptor.size : '' )
					).appendTo( this.Root() ) );

				const mh = ui.$$.div().addClass( 'modal-header' );

				if ( !( descriptor.noCloseBtn === true ) )
				{
					descriptor.head = descriptor.head || [];

					mh.append(
						ui.$$.button().append( ui.$$.span().addClass( 'fas fa-times' ).attr( 'aria-hidden', 'true' ) )
						.addClass( 'close' )
						.attr(
							{
								'aria-label': 'Close',
								'data-dismiss': 'modal',
								"type": 'button'
							},
						),
					).appendTo( cntnt );
				}

				if ( descriptor.head )
				{
					descriptor.head.forEach(
						(element) =>
						{
							if ( element instanceof ui.base.BaseHTMLElement )
							{
								element = element.Root();
							}

							element.appendTo( mh );
						},
					);

					if ( descriptor.noCloseBtn === false )
					{
						mh.appendTo( cntnt );
					}
				}

				if ( descriptor.body )
				{
					const mb = ui.$$.div().addClass( 'modal-body' ).appendTo( cntnt );
					descriptor.body.forEach(
						(element) =>
						{
							if ( element instanceof ui.base.BaseHTMLElement )
							{
								element = element.Root();
							}

							element.appendTo( mb );
						},
					);
				}

				if ( descriptor.foot )
				{
					const mf = ui.$$.div().addClass( 'modal-footer' ).appendTo( cntnt );
					descriptor.foot.forEach(
						(element) =>
						{
							if ( element instanceof ui.base.BaseHTMLElement )
							{
								element = element.Root();
							}

							element.appendTo( mf );
						},
					);
				}
			}

			public Show(): Modal
			{
				this.m_Root.modal( 'show' );

				return this;
			}

			public Hide(): Modal
			{
				this.m_Root.modal( 'hide' );

				return this;
			}

		}

	}
}
